<script lang="ts">
import Vue from 'vue'
import BaseModal from "@/components/ui/BaseModal.vue";
import CashButton from "@/views/partners/components/CashButton.vue";
import Button from "@/components/ui/Button.vue";
import { changeLimit, accountTopUpClient, accountWithdrawalPartner } from "@/api/partner"
import BalanceTag from "@/views/partners/components/BalanceTag.vue";
import LimitTag from "@/views/partners/components/LimitTag.vue";

export default Vue.extend({
    name: "ChangeBalanceLimit",
    components: {LimitTag, BalanceTag, Button, CashButton, BaseModal},
    props: ['partner'],
    data() {
        return {
            visible: false,
            balance: 0,
            limit: 0,
            errors: {},
        }
    },
    watch: {
        visible() {
            this.balance = 0
            this.limit = 0
        }
    },
    methods: {
        accountWithdrawalPartner() {
            accountWithdrawalPartner(this.partner.id, this.balance).then(() => {
                this.$message({
                    type: 'success',
                    message: 'Рахунок списано',
                });
                this.visible = false
                this.$emit('updated')
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    const errors = error.response.data.data;
                    if (errors && errors.amount) {
                        const allMessages = Object.values(errors.amount)
                            .flat() // якщо масив масивів
                            .join('<br>');
                        this.$set(this.errors, 'balance', allMessages);
                    }
                } else {
                    this.$set(this.errors, 'balance', error.response.data.message);
                }
            })
        },
        accountTopUpClient() {
            accountTopUpClient(this.partner.id, this.balance).then(() => {
                this.$message({
                    type: 'success',
                    message: 'Рахунок поповнення',
                });
                this.visible = false
                this.$emit('updated')
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    const errors = error.response.data.data;
                    if (errors && errors.amount) {
                        const allMessages = Object.values(errors.amount)
                            .flat() // якщо масив масивів
                            .join('<br>');
                        this.$set(this.errors, 'balance', allMessages);
                    }
                } else {
                    this.$set(this.errors, 'balance', error.response.data.message);
                }
            })
        },
        changeLimit() {
            changeLimit(this.partner.id, this.limit).then(() => {
                this.$message({
                    type: 'success',
                    message: 'Ліміт змінений',
                });
                this.visible = false
                this.$emit('updated')
            }).catch(error => {
                this.$set(this.errors, 'limit', error.response.data.message);
            })
        },
        clearError(type) {
            delete this.errors[type];
        }
    }
})
</script>

<template>
<div class="change-balance-limit">
    <CashButton @click="visible = true"/>
    <BaseModal v-model="visible">
        <div class="title">
            Редагувати баланс/ліміт точки продажу
        </div>
        <div class="row mt-4 mb-4">
            <div class="col-md-6 mb-3">
                <div class="d-flex mb-3 justify-content-center">
                    <b>Баланс (грн)</b> <BalanceTag class="ml-2">{{ partner.balance }}</BalanceTag>
                </div>
                <div class="form-group">
                    <label>Змінити баланс (грн)</label>
                    <input type="number"
                           :class="['form-control', errors['balance'] ? 'is-invalid' : '']"
                           v-model="balance"
                           @input="clearError('balance')"
                    >
                    <div v-if="errors['balance']" class="invalid-feedback d-block" v-html="errors['balance']">
                    </div>
                </div>
                <div class="footer">
                    <button type="button" class="btn btn-primary w-100" @click="accountWithdrawalPartner">Списати</button>
                    <button type="button" class="btn btn-replenish w-100" @click="accountTopUpClient">Поповнити</button>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="d-flex mb-3 justify-content-center">
                    <b>Ліміт (грн)</b> <LimitTag class="ml-2">{{ partner.limit || 0 }}</LimitTag>
                </div>
                <div class="form-group">
                    <label>Змінити ліміт (грн)</label>
                    <input type="number"
                           :class="['form-control', errors['limit'] ? 'is-invalid' : '']"
                           v-model="limit"
                           @input="clearError('limit')"
                    >
                    <div v-if="errors['limit']" class="invalid-feedback d-block">
                        {{ errors['limit'] }}
                    </div>
                </div>
                <div class="footer">
                    <button type="button" class="btn btn-primary w-100" @click="changeLimit">Застосувати</button>
                </div>
            </div>
        </div>
    </BaseModal>
</div>
</template>

<!--<style lang="scss">
@import '~bootstrap/dist/css/bootstrap.min.css';
</style>-->
<style scoped >
.change-balance-limit {
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type="number"] {
        -moz-appearance: textfield;
    }

     .content {
        width: 80%;
        .title {
            /* Редагувати баланс/ліміт точки продажу */
            font-family: 'Geist',serif;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 28px;
            /* identical to box height, or 117% */
            text-align: center;

            color: #09090B;
        }
/*        .row {
            flex-wrap: unset;
        }*/
        .footer {
            .btn {
                margin-bottom: 17px;
            }
            @media (min-width: 768px) {
                display: flex;
                gap: 18px;
                margin-top: 36px;
            }
        }
    }
    .btn-replenish {
        background-color: #FB923C;
        color: #FAFAFA;
    }
}
</style>
